import defaultNavbar from "./default";
import newsLetter from "./NewsLetter";
export default [defaultNavbar, newsLetter];
